/**
 * This file contains logic & styles shared by all pages in the configurator
 */

import $ from 'jquery';
import 'popper.js';
import 'bootstrap';

import { init as initApm } from '@elastic/apm-rum'

import '../scss/configurator.scss';
import { importSVG } from '../../shared/utils';
import { initializePopovers } from '../../shared/utils';

importSVG(require.context('/assets/configurator/svg', true, /\.svg$/));


//
// APM entrypoint
// TODO: Move this to shared/utils, it's also used for sites
//

if (kairos.config.APM_SERVER_URL) {
  initApm({

    // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
    serviceName: 'kairos-configurator',

    // Set custom APM Server URL (default: http://localhost:8200)
    serverUrl: kairos.config.APM_SERVER_URL,

    // Set service version (required for sourcemap feature)
    serviceVersion: ''
  });
}


/**
 * Set a css variable to the inner height of the window.
 *
 * This allows global acces to the height of the viewport, regardless of
 * browser decorations such as URL bars, open keyboards & other impediments
 * that are, by design, not accounted for in vh-based calculations
 *
 * https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser
 *
 * @return {integer} The height of the viewport
 */
function appHeight() {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
}
window.addEventListener('resize', appHeight);
appHeight();

$(function () {
  initializePopovers($);
});
